export default __webpack_public_path__ + "static/media/blue1.80632f94.gif";